import styles from "./Heading3.module.css";

export const Heading3 = ({ children, as = "h3" }) => {
  const Element = as;
  return <Element className={styles.title}>{children}</Element>;
};
